import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import type { NoteVersionOrigin } from '../../hooks/useKnowledge'
import { conversationSearch } from './conversationLink'

/**
 * Where a note version applied through a proposal came from (spec
 * 2026-11-01-01): the thread as a link when the reader may read it, the
 * assistant's person without a link, the proposer otherwise.
 */
export function VersionOrigin({ org, origin }: { org: string; origin: NoteVersionOrigin }) {
    const { t } = useTranslation('knowledge')
    const person = origin.person_name || t('version_origin.someone')

    return (
        <div className="text-xs text-muted-foreground" data-testid="note-version-origin" data-origin={origin.origin}>
            {origin.type === 'conversation' && origin.conversation_uid ? (
                <Link
                    to="/$org/conversations"
                    params={{ org }}
                    search={conversationSearch(origin.conversation_uid)}
                    className="text-primary hover:underline"
                    data-testid="note-version-origin-link"
                >
                    {origin.conversation_title
                        ? t('version_origin.conversation', { title: origin.conversation_title })
                        : t('version_origin.conversation_untitled')}
                </Link>
            ) : origin.type === 'assistant' ? (
                t('version_origin.assistant', { person })
            ) : (
                t('version_origin.proposer', { person })
            )}
        </div>
    )
}
